/**
 * Transforms the transaction data into a TransactionSummary
 *
 * @format
 * @param data The transaction summary data from `/transaction-service/${hash}/summary/`
 */
import {
    MixedTransaction,
    TransactionKind,
    TransactionSummary,
    TransactionVariant,
} from '@toucan/client/global/transaction';

export const isTransactionSummary = (
    summary?: MixedTransaction
): summary is TransactionSummary => {
    return summary?.kind === TransactionKind.TRANSACTION_SUMMARY;
};

export function isTransactionOfVariantType(
    transaction: MixedTransaction | undefined,
    variant: TransactionVariant
): boolean {
    if (!isTransactionSummary(transaction)) {
        return false;
    }
    return transaction.variant === variant;
}
